import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng';
import { VmePipesModule } from '../../../vme-pipes.module';
import { TravelSchedulerTask } from '../../../interfaces/travel-scheduler/travel-scheduler-task';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VehicleRegComponent } from '../../vehicle-reg/vehicle-reg.component';
import { SupplierJobsInboxModule } from '../../../modules/driver-experience/job-list/supplier-jobs-inbox.module';
import { VerticalDotsContainerComponent } from '../../../modules/driver-experience/job-list/vertical-dots-container.component';

@Component({
  selector: 'schedule-task-sequence-task',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    VmePipesModule,
    DragDropModule,
    VehicleRegComponent,
    VerticalDotsContainerComponent,
  ],
  templateUrl: './schedule-task-sequence-task.component.html',
  styleUrls: ['./schedule-task-sequence-task.component.css'],
})
export class ScheduleTaskSequenceTaskComponent implements OnInit {
  @Input() task!: TravelSchedulerTask;
  constructor() {}

  ngOnInit(): void {}

  @Input() isUpButtonEnabled: boolean = false;
  @Input() isDownButtonEnabled: boolean = true;
  @Output() onShiftPosition = new EventEmitter<number>();
}
